export default __webpack_public_path__ + "static/media/img_shouye_jishu_01.2392e9bf.png";